export default `
  fragment ImageElement on BoothDesignImageElement {
    image {
      ...CommonLocalizableImage
    }
  } 
`;
